import React from 'react'
import NotFound from '../Images/Logo/NotFound.png'

const Datanotfound = () => {
    return (
        <div className="notfound-container">
            <img src={NotFound} alt="No Data Available" />
            <h2>Oops! No Data Found</h2>
            <p>We couldn’t find any results for your request.</p>
        </div>

    )
}

export default Datanotfound